var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderReadonly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 10.79C2 13.253 2.748 14 5.21 14h5.58c2.462 0 3.21-.748 3.21-3.21V7.443c0-2.462-.748-3.21-3.21-3.21H9.117c-.346 0-.374-.033-.558-.279l-.837-1.116C7.33 2.318 7.023 2 6.047 2h-.838C2.748 2 2 2.748 2 5.21zM8 6c1.424 0 2.776.732 3.7 2.004.4.55.4 1.446 0 1.992a5.05 5.05 0 0 1-1.664 1.482A4.3 4.3 0 0 1 8 12c-1.424 0-2.776-.729-3.7-2.004-.4-.55-.4-1.443 0-1.992a5.05 5.05 0 0 1 1.664-1.482A4.3 4.3 0 0 1 8 6M6.384 9.002c0 .78.72 1.415 1.616 1.415s1.616-.634 1.616-1.415S8.896 7.587 8 7.587s-1.616.634-1.616 1.415",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderReadonly);
export default __webpack_public_path__ + "static/media/folderReadonly.8a50c7e63d098fba01478a0628e2b724.svg";
export { ForwardRef as ReactComponent };